// function MetricCard({ title, value }) {
//   return (
//     <div className="col-md-3">
//       <div className="border rounded p-3 h-100 bg-white">
//         <div className="text-muted small mb-1">{title}</div>
//         <div className="fw-semibold fs-5">{value}</div>
//       </div>
//     </div>
//   );
// }
// export default MetricCard;

import { ArrowUpRight, ArrowDownRight } from "react-bootstrap-icons";

export default function MetricCard({
  title,
  value,
  change,
  changeType = "neutral", // positive | negative | neutral
  subtitle,
  icon: Icon,
  loading = false,
  progress, // optional percentage number (0–100)
}) {
  const changeColor =
    changeType === "positive"
      ? "text-success"
      : changeType === "negative"
        ? "text-danger"
        : "text-muted";

  const ChangeIcon =
    changeType === "positive"
      ? ArrowUpRight
      : changeType === "negative"
        ? ArrowDownRight
        : null;

  return (
    <div
      className="card border-0 shadow-sm h-100"
      style={{
        borderRadius: 16,
        transition: "all 0.2s ease",
      }}
    >
      <div className="card-body d-flex flex-column gap-3">
        {/* Top Section */}
        <div className="d-flex justify-content-between align-items-start">
          {/* Title & Subtitle */}
          <div>
            <div className="text-muted small">{title}</div>

            {loading ? (
              <div
                className="bg-light rounded mt-2"
                style={{ height: 28, width: 120 }}
              />
            ) : (
              <div className="fs-4 fw-bold mt-1">{value}</div>
            )}

            {subtitle && (
              <div className="text-muted small mt-1">{subtitle}</div>
            )}
          </div>

          {/* Icon */}
          {Icon && (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: "#f8f9fa",
              }}
            >
              <Icon size={20} />
            </div>
          )}
        </div>

        {/* Change Indicator */}
        {!loading && change && (
          <div
            className={`d-flex align-items-center gap-1 small ${changeColor}`}
          >
            {ChangeIcon && <ChangeIcon size={16} />}
            <span className="fw-semibold">{change}</span>
          </div>
        )}

        {/* Optional Progress */}
        {typeof progress === "number" && (
          <div className="progress" style={{ height: 6 }}>
            <div
              className={`progress-bar ${
                changeType === "positive"
                  ? "bg-success"
                  : changeType === "negative"
                    ? "bg-danger"
                    : "bg-secondary"
              }`}
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
